
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo-wallet/desktop/view-your-wallet-address",
      function () {
        return require("private-next-pages/en/docs/komodo-wallet/desktop/view-your-wallet-address/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo-wallet/desktop/view-your-wallet-address"])
      });
    }
  